<template>
    <div class="w-100 h-100">
        <b-modal
            v-model="showModal"
            hide-header
            hide-header-close
            title="Data Submitted"
            centered
            @ok="clearFields"
        >
            <div class="text-center">
                <div>{{ModalMessage}}</div>
            </div>
        </b-modal>
      <b-container fluid>
        <h2 class="tw-mb-0 text-aegis-dk">RT PCR Processing</h2>
        <p class="tw-italic tw-text-gray-700">
          Blood sample processing
        </p>
      </b-container>
      <br />
  
      <!-- Show this row when page first loads -->
      <b-row v-if="blood_sample_id == ''">
        <b-col cols="3"></b-col>
        <b-col cols="4">
            <b-form-input
                v-model="aliquot_id"
                placeholder="Scan Aliquot Barcode"
                @keypress.enter="getData"
            ></b-form-input>
        </b-col>
        <b-col cols="2">
            <b-button
                @click="getData()"
                :disabled="aliquot_id == ''"
            >Submit</b-button>
        </b-col>
        <b-col cols="3"></b-col>
      </b-row>
      <!-- Show this after we know which Blood Sample Analysis object we need -->
      <b-row v-else>
        <b-col cols="2"></b-col>
        <b-col cols="8">
            <b-row>
                <b-col><h5>RT PCR Processing for Blood Sample ID: {{ blood_sample_id }}</h5></b-col>
            </b-row>
            <span v-for="field in form_fields" :key="field.key">
                <b-row class="mt-2">
                    <b-col>
                        <b-form-group
                            :id=field.key
                            :label=field.text
                        >
                            <b-form-input
                                v-model="field.value"
                                :placeholder=field.text
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </span>
            <b-button
                class="mt-2"
                variant="success"
                size="lg"
                block
                @click="getData('update')"
                :disabled="processing_submit_disabled"
            >Submit Data</b-button>
        </b-col>
        <b-col cols="2"></b-col>
      </b-row>
    </div>
  </template>
  
<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import * as _ from "lodash";
  
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
  
export default {
mixins: [
    DashboardBaseTemplate,
],
components: {},
props: {},
data: function() {
    return {
        showModal: false,
        ModalMessage: '',
        blood_sample_id: '',
        blood_sample_analysis_id: '',
        aliquot_id: '',
        form_fields: [
            { key: 'rt_pcr_dengue_v1_ct_value', value: '', text: 'Dengue V1 Ct Value' },
            { key: 'rt_pcr_dengue_v2_ct_value', value: '', text: 'Dengue V2 Ct Value' },
            { key: 'rt_pcr_dengue_v3_ct_value', value: '', text: 'Dengue V3 Ct Value' },
            { key: 'rt_pcr_dengue_v4_ct_value', value: '', text: 'Dengue V4 Ct Value' }
        ],
    };
},
computed: {
    processing_submit_disabled:function () {
        let disabled = false;
        _.each(this.form_fields, function(field) {
            if (field.value == null || field.value == '') {
                disabled = true;
            }
        });
        return disabled;
    }
},
watch: {},
created: function() {},
mounted: function() {},
methods: {
    getData: function(mode = null) {
        const that = this;
        const fd = new FormData();
        fd.append("aliquot_id", that.aliquot_id);
        
        if (mode == "update") {
            fd.append("mode", mode);
            _.each(this.form_fields, function(field) {
                fd.append(field.key, field.value);
            });
        }
        HTTP.post('srilanka/blood_sample/rtpcr_processing/', fd).then((response) => {
            that.blood_sample_id = response.data.blood_sample_id;
            that.blood_sample_analysis_id = response.data.blood_sample_analysis_id;

            _.each(that.form_fields, function(field) {
                field.value = response.data[field.key];
            });
            if (mode == 'update') {
                this.ModalMessage = 'Submitted successfully';
                this.showModal = true;
            }
        }).catch((error) => {
            this.ModalMessage = 'There was a problem. Please check input values and try again.';
            this.showModal = true;
            HandleErrors.HandleErrors(error);
        });
    },
    clearFields() {
        this.blood_sample_id = '';
        this.blood_sample_analysis_id = '';
        this.aliquot_id = '';
        _.each(this.form_fields, function(field) {
            field.value = '';
        });
    }
}
};
</script>

<style scoped></style>
  